var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "module-content" }, [
      _c("div", { staticClass: "module-header" }, [
        _vm._m(0),
        !_vm.isLoadingDonations && !_vm.isDownloading && !_vm.isMarkingExports
          ? _c(
              "div",
              { staticClass: "right" },
              [
                _c("DatePicker", {
                  attrs: { dateRange: _vm.settings.dateRange },
                  on: { dateSelected: _vm.dateSelected }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      !_vm.isLoadingDonations && !_vm.isDownloading && !_vm.isMarkingExports
        ? _c("div", { staticClass: "container" }, [
            _c(
              "div",
              {
                staticClass: "table-wrapper",
                staticStyle: { height: "90%", "margin-bottom": "10px" }
              },
              [
                _c("Table", {
                  attrs: {
                    items: _vm.donations["All"],
                    attributes: _vm.tableAttributes,
                    options: _vm.tableOptions
                  }
                })
              ],
              1
            ),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.downloadFiles()
                  }
                }
              },
              [
                _vm._v(" Download "),
                _c("i", { staticClass: "icn icn-document-download" })
              ]
            ),
            _c(
              "button",
              {
                staticStyle: { "margin-left": "30px" },
                on: {
                  click: function($event) {
                    return _vm.markAsExported()
                  }
                }
              },
              [
                _vm._v(" Mark donations as exported "),
                _c("i", { staticClass: "icn icn-check-circle" })
              ]
            )
          ])
        : _vm._e(),
      _vm.isDownloading
        ? _c("div", { staticClass: "container w-max" }, [_vm._m(1)])
        : _vm._e(),
      _vm.isLoadingDonations
        ? _c("div", { staticClass: "container w-max" }, [_vm._m(2)])
        : _vm._e(),
      _vm.isMarkingExports
        ? _c("div", { staticClass: "container w-max" }, [_vm._m(3)])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h1", [_vm._v("Exports Data")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("h2", [_vm._v("Downloading files")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("h2", [_vm._v("Fetching donations")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("h2", [_vm._v("Marking donations as exported")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }